import React from "react";
import Accordion from 'react-bootstrap/Accordion';


const FAQ = () => {
    return (
        <div className="FAQ ">
            <div className="container">
                <h5 className="text-center text-white my-20">Frequently Asked Questions</h5>
                <div className="mx-auto mb-70 mt-70" style={{maxWidth:"920px"}}>
                    <Accordion defaultActiveKey="0">
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>How to become seller on iWant Asia?</Accordion.Header>
                        <Accordion.Body>
                        This is the body of the first accordion item. It contains some text and can be expanded or collapsed.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Is there any marketing support from iWant Asia?</Accordion.Header>
                        <Accordion.Body>
                        This is the body of the second accordion item. It can contain various content, such as lists, images, or other components.
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Does Pink Peony connect the product link to the seller website?</Accordion.Header>
                        <Accordion.Body>
                        This is the body of the second accordion item. It can contain various content, such as lists, images, or other components.
                        </Accordion.Body>
                    </Accordion.Item>
                    </Accordion>
                </div>
                
            </div>
        </div>

         
    )
}

export default FAQ;